import {
  Component,
  ChangeDetectionStrategy,
  Input,
  OnInit,
} from '@angular/core';
import { IIcon, IconSizesEnum } from 'i2g-ng-ui';

@Component({
  selector: 'app-form-banner',
  templateUrl: 'form-banner.component.html',
  styleUrls: ['form-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormBannerComponent implements OnInit {
  @Input() message: string;
  @Input() bannerStyle: 'success' | 'error';

  icon: IIcon;

  constructor() {}

  ngOnInit() {
    if (this.bannerStyle === 'error') {
      this.icon = {
        name: 'error',
        size: IconSizesEnum.small,
      };
    }
  }
}
